import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getAcastEpisode } from "../../helper/api";
import { PodcastPodcatcherSubscribeList } from "../podcast-podcatcher-subscribe-list";
import DownloadButton from "../../download-button";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import { getGlobalPlayerRef } from "../../podcast-player/utils";
import { PauseButton, PlayButton } from "../../podcast-player/icons";
import { parseUrl } from "query-string";
import get from "lodash/get";
import { Loader } from "../../podcast-player/Loader";
import { useDispatch, useSelector } from "react-redux";
import {UsersOnlyNudge} from "../../floating-pod-button/UsersOnlyNudge"
import "./episode-play-button.m.css";

export function EpisodePlayButton(props) {

  const [track, setTrack] = useState({});
  const [playerState, setPlayerState] = useState({});
  const member = useSelector(state => state.member);
  const authHost= useSelector(state => get(state,["qt", "config", "publisher", "publisher", "auth_host"], null));
  const currentPath = useSelector(state => get(state, ["qt", "currentPath"], ""));
  const params = parseUrl(currentPath);
  const callbackUrl = get(params, ["query", "callback-url"], global.location && global.location.origin);
  const redirectUrl = get(params, ["query", "redirect-url"], global && global.location && global.location.href);
  const url =`${authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${authHost}/user-login`;
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [Modal, setModal] = useState(false);

  useEffect(() => {
    const playerRef = getGlobalPlayerRef();
    const removeListener = playerRef.addPlayerListener(state => {
      setPlayerState(state);
    });

    async function getAndLoadEpisode() {
      // eslint-disable-next-line camelcase
      const { episode_id, show_id } = props.data;
      const data = await getAcastEpisode(show_id, episode_id);
      setTrack(data.episode);
    }

    getAndLoadEpisode();

    return removeListener;
  }, []);

  const isLoading =
    (playerState.audioStatus === "loading" && playerState.currentTrackId === track._id) || playerState.loadingUserQueue;
  const isPlaying = playerState.audioStatus === "playing" && playerState.currentTrackId === track._id;
  const isLoaded = playerState.currentTrackId === track._id;
  const dispatch = useDispatch();

  const playEpisode = async () => {
    const playerRef = getGlobalPlayerRef();
    if (isPlaying) {
      playerRef.pause();
    } else if (isLoaded) {
      playerRef.play();
    } else {
      playerRef.playTrack({ ...track, podcast: {} });
      playerRef.setState({ showPlayer: true });
    }
  };

  const renderPlayButton = episode => {
    if (isPlaying) {
      return (
        <button aria-label="Pause" title="Pause" className="pressable" onClick={()=>{member?playEpisode():setModal(true)}}>
          <PauseButton width={20} fill={"#e3e2e2"} />
        </button>
      );
    } else if (isLoading) {
      return (
        <button aria-label="loading" title="Loading" className="pressable" aria-disabled={true}>
          <Loader />
        </button>
      );
    } else {
      return (
        <button aria-label="Play" title="Play" className="pressable" onClick={()=>{member?playEpisode():setModal(true)}}>
          <PlayButton width={20} fill={"#e3e2e2"} />
        </button>
      );
    }
  };

  return (<>
    <div styleName="button-wrapper">
      {track && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            {renderPlayButton()}
            <div styleName="track-meta">
              <div styleName="track-title">{track.title}</div>
            </div>
          </div>

          <div styleName="button-options">
            <button styleName="button-subscribe" onClick={() => setShowSubscribeModal(true)}>
              Follow
            </button>
            {/* <DownloadButton href={track.audio} /> */}
          </div>
          <PodcastPodcatcherSubscribeList
            showId={track.show}
            show={showSubscribeModal}
            onClose={() => setShowSubscribeModal(false)}
          />
        </>
      )}
    </div>
    {Modal && <UsersOnlyNudge handleClose={()=>{setModal(false)}} redirectionUrl={url}/> }

    </>
  );
}

EpisodePlayButton.propTypes = {
  data: PropTypes.object
};
